import { useMutation } from '@apollo/client';
import axios from 'axios';
import CrossMarkAlt from 'components/Icons/CrossMarkAlt';
import Info from 'components/Icons/Info';
import PlusAlt from 'components/Icons/PlusAlt';
import TrashOutlined from 'components/Icons/TrashOutlined';
import Input from 'components/Input/Input';
import UICreatePDSelect, {
  NewPDValue
} from 'components/Others/UICreatePDSelect';
import UIPDSelect, { PDOption } from 'components/Others/UIPDSelect';
import UITooltip from 'components/Others/UITooltip';
import Link from 'next/link';
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import Resizer from 'react-image-file-resizer';
import { useDispatch, useSelector } from 'react-redux';
import { setShowModal, setUseThisPD } from 'redux/features/pd/pdSlice';
import prescriptionService from 'services/prescription.service';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { showWarningMessage } from 'utils/toast.util';
import { useGlassesStore } from 'zus/glassesStore';
import { notifications } from '../../constants/notificationMessages';
import {
  CREATE_PRESCRIPTION_AND_PD,
  EDIT_PRESCRIPTION_AND_PD
} from '../../gqlStrings/mutations/Prescription';
import useWindowSize from '../../hooks/useWindowSize';
import { addDataLayer } from '../../lib/ga';
import {
  setOpenPrescriptionGuestForm, setOpenUploadPrescriptionGuestForm, setPds, setPrescriptions, setSelectBoxPrescription, setSelectEditedPrescription, setSelectedPrescription, setUsePrescriptionButton
} from '../../redux/features/prescription/prescriptionSlice';
import { RootState } from '../../redux/store';
import Button from '../Button/Button';
import SelectIcon from '../Icons/SelectIcon';
import Trash from '../Icons/Trash';
import PrescriptionSelectBox from '../SelectBox/PrescriptionSelectBox';
import Spinner from '../Spinner/Spinner';
import { ALLOWED_FILE_EXTENSIONS } from './PrescriptionUploadDropzone';
import { useProductStore } from 'zus/productStore';
import UIButton from 'components/Others/UIButton';
import Edit from 'components/Icons/Edit';
import DocumentUpload from 'components/Icons/DocumentUpload';
import AddNote from 'components/Icons/AddNote';
import { ProductFeatureBoxProps } from 'constants/dataTypes';
import useHeaderHelpers, {
  MenuActionClickHandler,
  UserMenuAction
} from 'components/Header/Shared/useHeaderHelpers';
import { openAuth } from 'redux/features/auth/authSlice';
import AccountAlt from 'components/Icons/AccountAlt';
import TrashAlt from 'components/Icons/TrashAlt';
import Checkmark from 'components/Icons/Checkmark';
import cx from 'classnames';
import UIModal from 'components/Others/UIModal';
import PrescriptionUploadForm from './PrescriptionUploadForm';
import CrossMark from 'components/Icons/CrossMark';
import { useRouter } from 'next/router';
import PrescriptionLeftArrow from 'components/Icons/PrescriptionLeftArrow';



export default function PrescriptionFormV2({
  setPrescriptionAddForm,
  setHome,
  profile,
  productFeatureCache,
  handleState,
  handlePrescriptionUploadForm,
  isProfilePage = false,
}: {
  setPrescriptionAddForm?: React.Dispatch<React.SetStateAction<any>>;
  setHome?: React.Dispatch<React.SetStateAction<boolean>>;
  profile?: any;
  productFeatureCache: any;
  handleState?: any;
  handlePrescriptionUploadForm?: any;
  isProfilePage?: boolean;
}) {
  const selectEditedPrescription = useSelector(
    (state: RootState) => state.prescriptionEvent.selectEditedPrescription
  );

  const router = useRouter();

  const purpose = useGlassesStore((state) => state.purpose)

  const isMultifocal = purpose === 'multifocal';
  const isBifocal = purpose === 'bifocal';
  const isReading = purpose === 'reading';
  const isDistance = purpose === 'distance';

  const isMultifocalOrBifocal = isMultifocal || isBifocal;

  const frameSize = useGlassesStore((state) => state.frame_size)
  const armsSize = useGlassesStore((state) => state.arms_size)

  const usePDMeter = useSelector((state: any) => state.pdEvent.setPD)
  const calculatedPd = useSelector((state: any) => state.pdEvent.calculatedPd)
  const centerToIris = useSelector((state: any) => state.pdEvent.centerToIris)

  const setActiveSelection = useProductStore((state: any) => state.setActiveSelection)
  const setActiveSelectionIdx = useProductStore((state: any) => state.setActiveSelectionIdx)
  const prescriptionShowStep = useProductStore((state: any) => state.prescriptionShowStep);
  const setPrescriptionShowStep = useProductStore((state: any) => state.setPrescriptionShowStep);
  const setPriscriptionFormValues = useProductStore((state: any) => state.setPriscriptionFormValues)
  const priscriptionFormValues = useProductStore((state: any) => state.priscriptionFormValues)

  const [selectedPdId, setSelectedPdId] = useState('');
  const [showPDMeter, setshowPDMeter] = useState(false)
  // const [prescriptionUploadForm, setPrescriptionUploadForm] = useState(false);
  const uploadFormOpen = useProductStore((state: any) => state.uploadFormOpen);
  const uploadFormFileSelected = useProductStore((state: any) => state.uploadFormFileSelected);

  const setUploadFormOpen = useProductStore((state: any) => state.setUploadFormOpen);
  const setUploadFormFileSelected = useProductStore((state: any) => state.setUploadFormFileSelected);

  const setPrescriptionUploadForm = useProductStore((state: any) => state.setPrescriptionUploadForm);
  const prescriptionUploadForm = useProductStore((state: any) => state.prescriptionUploadForm);
  const [isFileSelected, setIsFileSelected] = useState<any>(false)

  const tooltipMessageLocale: any = {
    au: <div><span className='font-medium'>A valid prescription within the past 24 months is required for the supply of prescription glasses.</span> Don’t have a valid prescription? <a className="text-brand-blue" href="/au/book-an-optometrist">Book an appointment</a> with us or call us at (02) 5300 3003.</div>,
    ca: <div><span className='font-medium'>A valid prescription within the past 24 months is required for the supply of prescription glasses.</span> Don’t have a valid prescription? <a className="text-brand-blue" href="/ca/book-an-eye-exam">Book an appointment</a> with us or call us at (647) 424 4288.</div>,
    nz: <div><span className='font-medium'>A valid prescription within the past 24 months is required for the supply of prescription glasses.</span> Don’t have a valid prescription? Call us at 0800 447 111.</div>,
    international: <div><span className='font-medium'>A valid prescription within the past 24 months is required for the supply of prescription glasses.</span> Don’t have a valid prescription? Call us at +1 (213) 223-6100.</div>,
  }
  const [haveValidPrescription, setHaveValidPrescription] = useState(false)
  //const pdSelectionType = useProductStore((state:any) => pdSelectionType);
  //const setPdSelectionType = useProductStore((state:any) => setPdSelectionType);
  const cancelFileSelected = () => {
    //setIsFileSelected(() => false)
    //setPrescriptionUploadForm(() => !prescriptionUploadForm)
  }
  const [newPd, setNewPd] = useState<NewPDValue>({
    type: 'bino',
    left: '',
    right: '',
    pd: '',
    source: 'we'
  });

  const MySwal = withReactContent(Swal);
  const {
    register,
    watch,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    clearErrors
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      sphereR:
        (selectEditedPrescription && selectEditedPrescription.right_sph) || priscriptionFormValues?.sphereR || '0',
      axisL:
        (selectEditedPrescription && (selectEditedPrescription.left_axis == '0' ? '' : selectEditedPrescription.left_axis)) || priscriptionFormValues?.axisL || '',
      cylinderL:
        (selectEditedPrescription && selectEditedPrescription.left_cyl) || priscriptionFormValues?.cylinderL || '0',
      sphereL:
        (selectEditedPrescription && selectEditedPrescription.left_sph) || priscriptionFormValues?.sphereL || '0',
      axisR:
        (selectEditedPrescription && (selectEditedPrescription.right_axis == '0' ? '' : selectEditedPrescription.right_axis)) || priscriptionFormValues?.axisR ||
        '',
      cylinderR:
        (selectEditedPrescription && selectEditedPrescription.right_cyl) || priscriptionFormValues?.cylinderR || '0',
      note: (selectEditedPrescription && selectEditedPrescription.note) || priscriptionFormValues?.note || '',
      // pd:
      //   selectEditedPrescription &&
      //   selectEditedPrescription.pd &&
      //   selectEditedPrescription.pd.binocular_dist_pd,
      // pdR:
      //   selectEditedPrescription &&
      //   selectEditedPrescription.pd &&
      //   selectEditedPrescription.pd.right_monocular_dist_pd,
      // pdL:
      //   selectEditedPrescription &&
      //   selectEditedPrescription.pd &&
      //   selectEditedPrescription.pd.left_monocular_dist_pd,
      addL:
        (selectEditedPrescription && selectEditedPrescription.left_near_add) || (isBifocal && (parseFloat(priscriptionFormValues?.addL) > 3) ? 0 : priscriptionFormValues?.addL) ||
        '0',
      addR:
        (selectEditedPrescription && selectEditedPrescription.right_near_add) || (isBifocal && (parseFloat(priscriptionFormValues?.addR) > 3) ? 0 : priscriptionFormValues?.addR) ||
        '0',
      file: null
    }
  });
  const onError = () => {
    addDataLayer({ event: 'prescription_fail' }, false);
  };

  const [pdSelectionType, setPdSelectionType] = useState<'SELECT' | 'CREATE'>(
    'CREATE'
  );

  const [pdList, setPdList] = useState<PDOption[]>([]);

  const [isPdListLoading, setIsPdListLoading] = useState(true);

  const loadPdList = async () => {
    const calculatedPd = JSON.parse(localStorage.getItem('calculatedPd') || '{}');
    if (calculatedPd) {
      if (newPd.type == 'mono') {
        setNewPd(Object.assign({}, newPd, { "left": calculatedPd.monoPD, "right": calculatedPd.monoPD, "source": "we" }))
      } else {
        setNewPd(Object.assign({}, newPd, { "pd": calculatedPd.pd, "source": "we" }))
      }
    }

    if (!isLogin) {
      setPdSelectionType('CREATE');
      setIsPdListLoading(false);
      if (selectEditedPrescription) {

        setNewPd({
          type: selectEditedPrescription.pd.binocular_dist_pd ? 'bino' : 'mono',
          pd: selectEditedPrescription.pd.binocular_dist_pd,
          left: selectEditedPrescription.pd.left_monocular_dist_pd,
          right: selectEditedPrescription.pd.right_monocular_dist_pd
        });
      }
      return;
    }
    setIsPdListLoading(true);
    const savedPdList = await prescriptionService.findAllPds(
      frameSize as string
    );
    setPdList(savedPdList);
    if (!savedPdList.length) {
      setPdSelectionType('CREATE');
    }
    if (savedPdList.length === 1) {
      setSelectedPdId(savedPdList[0].id);
    }

    setIsPdListLoading(false);
  };

  useEffect(() => {
    loadPdList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedPrescription = useSelector(
    (state: RootState) => state.prescriptionEvent.selectedPrescription
  );

  const isLogin = useSelector((state: RootState) => state.authEvent.isLogin);

  const prescriptions = useSelector(
    (state: RootState) => state.prescriptionEvent.prescriptions
  );

  const authToken = useSelector(
    (state: RootState) => state.authEvent.authToken
  );


  const checkCylinderAndAxisValueMismatchError = (data: any) => {
    const cylinderR = Number(data.cylinderR);
    const cylinderL = Number(data.cylinderL);
    const axisR = Number(data.axisR);
    const axisL = Number(data.axisL);

    if ((cylinderL && !axisL) || (cylinderR && !axisR)) {
      showWarningMessage(notifications.PRES_CYL_AXIS_MISMATCH_ERROR, false);
      return true;
    }

    return false;
  };

  let refTooltipSinglePd: any;
  let refTooltipMultiPd: any;
  let refTooltipPd: any;
  const [pdType, setPdType] = useState('single');
  const { width } = useWindowSize();
  const [fileUpload, setFileUpload] = useState(false);
  const [file, setFile] = useState(null);
  const [buttonSticky, setButtonSticky] = useState(true);
  const [fileRemoved, setFileRemoved] = useState(false);
  const [fileRemovedLoading, setFileRemovedLoading] = useState(false);
  const [fileSrc, setFileSrc] = useState<any>(null);
  const [fileIsPdf, setFileIsPdf] = useState<any>(false);
  const [multifocalAddLConfirm, setMultifocalAddLConfirm] =
    useState<boolean>(false);
  const [multifocalAddLValue, setMultifocalAddLValue] = useState<any>(null);

  const [fileName, setFileName] = useState<any>(null);

  // eslint-disable-next-line no-unused-vars
  const [selected, setSelected] = useState(selectedPrescription);
  const [createPrescriptionLoading, setCreatePrescriptionLoading] =
    useState(false);

  const [addNote, setAddNote] = useState(false);
  const [attachPriscription, setAttachPriscription] = useState(false);


  const dispatch = useDispatch();

  useEffect(() => {
    if (multifocalAddLConfirm) {
      setValue('addL', multifocalAddLValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multifocalAddLConfirm, multifocalAddLValue]);

  useEffect(() => {
    setSelected(selectedPrescription);
  }, [selectedPrescription]);

  function createPrescriptionValue(
    max: any,
    min: any,
    reverse: boolean = true,
    add: number = 0.25,
    plus: boolean = true
  ) {
    const options = [];
    var id = 1;
    for (let i = min; i <= max; i += add) {
      options.push({
        id: id,
        value: i,
        name:
          (plus ? (i > 0 ? '+' : '') : '') +
          (plus ? (Math.round(i * 100) / 100).toFixed(2) : i)
      });
      id += 1;
    }
    if (reverse) {
      options.reverse();
    }
    return options;
  }

  const addZero = (options: any) => {
    options.push({
      id: 0,
      value: 0,
      name: Number(0).toFixed(2)
    });

    return options;
  };

  const [mutatePrescriptionFunction] = useMutation(CREATE_PRESCRIPTION_AND_PD, {
    context: {
      clientName: 'laravel',
      upload: true
    },
    onCompleted: async (getUserData) => {
      addDataLayer({ event: 'prescription_success' }, false);
      if (isLogin) {
        const NewPrescription = Object.assign([], prescriptions);
        NewPrescription.unshift(getUserData.createPrescriptionAndPd);
        dispatch(setPrescriptions(NewPrescription));
        const updatedPds = await prescriptionService.findAllPds(
          frameSize as string
        );
        dispatch(setPds(updatedPds));
        if (setHome) {
          setHome(true);
        }
        if (setPrescriptionAddForm) {
          setPrescriptionAddForm(false);
        }
      }

      dispatch(setSelectedPrescription(getUserData.createPrescriptionAndPd));
      dispatch(setSelectBoxPrescription(getUserData.createPrescriptionAndPd));
      dispatch(setUsePrescriptionButton(true));
      setCreatePrescriptionLoading(false);

      if (!isLogin) {
        document
          .getElementsByTagName('body')[0]
          .classList.remove('overflow-hidden-body');

        dispatch(setOpenPrescriptionGuestForm(false));
      }
      toast.custom((t) => (
        <div
          onClick={() => toast.dismiss(t.id)}
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-green p-4 text-center text-sm font-medium text-white shadow-lg`}>
          {notifications.CREATE_PRESCRIPTION}
        </div>
      ));
    },
    onError: (error) => {
      addDataLayer({ event: 'prescription_fail' }, false);
      setCreatePrescriptionLoading(false);
      toast.custom((t) => (
        <div
          onClick={() => toast.dismiss(t.id)}
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-red p-4 text-center text-sm font-medium text-white shadow-lg`}>
          {error.message}
        </div>
      ));
    }
  });

  const [mutateEditPrescriptionFunction] = useMutation(
    EDIT_PRESCRIPTION_AND_PD,
    {
      context: {
        clientName: 'laravel',
        upload: true
      },
      onCompleted: (getUserData) => {
        if (!isLogin) {
          document
            .getElementsByTagName('body')[0]
            .classList.remove('overflow-hidden-body');

          dispatch(setOpenPrescriptionGuestForm(false));
          dispatch(setSelectedPrescription(getUserData.editPrescriptionAndPd));
          dispatch(setSelectEditedPrescription(null));
        } else {
          const updatedPrescriptions = prescriptions.map((el: { id: any }) =>
            el.id === getUserData.editPrescriptionAndPd.id
              ? getUserData.editPrescriptionAndPd
              : el
          );
          dispatch(setPrescriptions(updatedPrescriptions));

          if (
            selectedPrescription.id === getUserData.editPrescriptionAndPd.id
          ) {
            dispatch(
              setSelectedPrescription(getUserData.editPrescriptionAndPd)
            );
          }
          if (setHome) {
            setHome(true);
          }
          if (setPrescriptionAddForm) {
            setPrescriptionAddForm(false);
          }
          dispatch(setSelectEditedPrescription(null));
        }
        toast.custom((t) => (
          <div
            onClick={() => toast.dismiss(t.id)}
            className={`${t.visible ? 'animate-enter' : 'animate-leave'
              } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-green p-4 text-center text-sm font-medium text-white shadow-lg`}>
            {notifications.EDIT_PRESCRIPTION}
          </div>
        ));
      },
      onError: (error) => {
        setCreatePrescriptionLoading(false);
        toast.custom((t) => (
          <div
            onClick={() => toast.dismiss(t.id)}
            className={`${t.visible ? 'animate-enter' : 'animate-leave'
              } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-red p-4 text-center text-sm font-medium text-white shadow-lg`}>
            {error.message}
          </div>
        ));
      }
    }
  );

  const checkReadingNearAdd = async () => {
    const result = await MySwal.fire({
      width: 600,
      html: (
        <div>
          <p className="text-base ">
            {notifications.READING_ADD_VALUE}
          </p>
          <div className="mt-4 flex w-full items-center justify-center">
            <button
              className="mr-3 rounded bg-brand-black50 px-5 py-2 text-sm text-white"
              onClick={() => {
                MySwal.clickConfirm();
              }}>
              Confirm
            </button>
            <button
              className="rounded border border-brand-grey175 bg-white px-5 py-2 text-sm text-brand-black50"
              onClick={() => MySwal.close()}>
              Cancel
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false
    });

    if (result.isConfirmed) {
      return true;
    }
    return false;
  }

  const checkSphDiffrent = async () => {
    const result = await MySwal.fire({
      width: 600,
      html: (
        <div>
          <p className="text-base ">
            {notifications.SPH_DIFFRENT}
          </p>
          <div className="mt-4 flex w-full items-center justify-center">
            <button
              className="mr-3 rounded bg-brand-black50 px-5 py-2 text-sm text-white"
              onClick={() => {
                MySwal.clickConfirm();
              }}>
              Confirm
            </button>
            <button
              className="rounded border border-brand-grey175 bg-white px-5 py-2 text-sm text-brand-black50"
              onClick={() => MySwal.close()}>
              Cancel
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false
    });

    if (result.isConfirmed) {
      return true;
    }
    return false;
  }

  const handleLogin = () => {
    console.log("handle login")
    dispatch(openAuth());
    dispatch(setOpenPrescriptionGuestForm(false));
    dispatch(setSelectEditedPrescription(null));
    dispatch(setOpenUploadPrescriptionGuestForm(false));

  }

  const handleMySavedPrescriptions = () => {
    handleState();
    setPrescriptionShowStep('PRESCRIPTION_LIST');
  }

  const handleUploadPrescription = () => {
    handlePrescriptionUploadForm();

  }

  async function onPrescriptionSubmit(data: any) {
    dispatch(setSelectedPrescription(null));
    if (!haveValidPrescription) {
      return;
    }

    if (isMultifocal && data.addR === '0' && data.addL === '0') {
      showWarningMessage(notifications.MULTIFOCAL_ADD_VALUE, false);
      return;
    }

    if (isBifocal && data.addR === '0' && data.addL === '0') {
      showWarningMessage(notifications.BIFOCAL_ADD_VALUE, false);
      return;
    }

    if (isReading && data.addR == '0' && data.addL == '0') {
      const checkReading = await checkReadingNearAdd();
      if (!checkReading) {
        return;
      }
    }

    if ((Number(data.sphereR) > 0 && Number(data.sphereL) < 0) || (Number(data.sphereR) < 0 && Number(data.sphereL) > 0)) {
      const checkReading = await checkSphDiffrent();
      if (!checkReading) {
        return;
      }
    }

    if (
      data.axisR < 0 ||
      data.axisR > 180 ||
      data.axisL < 0 ||
      data.axisL > 180 ||
      (data.cylinderR !== '0' && data.axisR <= 0) ||
      (data.cylinderR !== '0' && data.axisR > 180) ||
      (data.cylinderL !== '0' && data.axisL <= 0) ||
      (data.cylinderL !== '0' && data.axisL > 180)
    ) {
      showWarningMessage(notifications.AXIS_ERROR, false);
      return;
    }

    if (
      (data.cylinderR === '0' && data.axisR > 0) ||
      (data.cylinderL === '0' && data.axisL > 0)
    ) {
      showWarningMessage(notifications.CYL_ERROR, false);
      return;
    }




    if (
      data.sphereR === '0' &&
      data.cylinderR === '0' &&
      data.addR === '0' &&
      data.sphereL === '0' &&
      data.cylinderL === '0' &&
      data.addL === '0'
    ) {
      showWarningMessage(notifications.PRES_FIELD_ERROR, false);
    } else {

      // set next step global state
      if (checkCylinderAndAxisValueMismatchError(data)) {
        return;
      }
      //console.log("test")

      setActiveSelection("pd");
      setActiveSelectionIdx(2);
      router.push('#pd');
      //  console.log(data)
      //debugger;
      //console.log(data);
      //dispatch(setSelectedPrescription(data));
      console.log(data)
      setPriscriptionFormValues({ ...data, file, arm_size: armsSize, frame_size: frameSize })

      // setCreatePrescriptionLoading(true);
      // if (selectedPdId) {
      //   mutatePrescriptionFunction({
      //     variables: {
      //       input: {
      //         left_near_add: data.addL,
      //         right_near_add: data.addR,
      //         right_sph: data.sphereR,
      //         left_axis: data.axisL || '0',
      //         left_cyl: data.cylinderL,
      //         left_sph: data.sphereL,
      //         right_axis: data.axisR || '0',
      //         right_cyl: data.cylinderR,
      //         note: data.note,
      //         pdId: selectedPdId,
      //         pdType: pdType,
      //         add_type: 'monocular',
      //         frame_size: frameSize,
      //         arm_size: armsSize,
      //         file: file
      //       }
      //     }
      //   });
      //   return;
      // }
      // mutatePrescriptionFunction({
      //   variables: {
      //     input: {
      //       left_near_add: data.addL,
      //       right_near_add: data.addR,
      //       right_sph: data.sphereR,
      //       left_axis: data.axisL || '0',
      //       left_cyl: data.cylinderL,
      //       left_sph: data.sphereL,
      //       right_axis: data.axisR || '0',
      //       right_cyl: data.cylinderR,
      //       note: data.note,
      //       pdType: newPd.type === 'bino' ? 'single' : 'multi',
      //       pdSource: newPd.source,
      //       binocular_dist_pd: newPd.pd,
      //       right_monocular_dist_pd: newPd.right,
      //       left_monocular_dist_pd: newPd.left,
      //       add_type: 'monocular',
      //       frame_size: frameSize,
      //       arm_size: armsSize,
      //       file: file
      //     }
      //   }
      // });
    }
  }

  const isPdValueEmpty = useMemo(() => {
    if (createPrescriptionLoading) return true;

    if (pdSelectionType === 'CREATE') {
      return newPd.type === 'bino' ? !newPd.pd : !newPd.right || !newPd.left;
    }

    return !selectedPdId;
  }, [
    createPrescriptionLoading,
    newPd.left,
    newPd.pd,
    newPd.right,
    newPd.type,
    pdSelectionType,
    selectedPdId
  ]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name == 'addR' && (isMultifocal || isBifocal || isReading) && !multifocalAddLConfirm) {
        setValue('addL', value.addR);
      }

      if (
        name == 'addL' &&
        value.addL != value.addR &&
        (isMultifocal || isBifocal || isReading) &&
        !multifocalAddLConfirm
      ) {
        var selectedValueAddL = value.addL;
        setValue('addL', value.addR);
        MySwal.fire({
          width: 600,
          html: (
            <div>
              <p className="text-base ">
                In general, ADD values are the same for both eyes. Please
                confirm your prescription indicates separate ADD values for
                right and left eyes.
              </p>
              <div className="mt-4 flex w-full items-center justify-center">
                <button
                  className="mr-3 rounded bg-brand-black50 px-5 py-2 text-sm text-white"
                  onClick={() => {
                    MySwal.clickConfirm();
                  }}>
                  Confirm
                </button>
                <button
                  className="rounded border border-brand-grey175 bg-white px-5 py-2 text-sm text-brand-black50"
                  onClick={() => MySwal.close()}>
                  Cancel
                </button>
              </div>
            </div>
          ),
          showConfirmButton: false
        }).then((result) => {
          if (result.isConfirmed) {
            setMultifocalAddLConfirm(true);
            setMultifocalAddLValue(selectedValueAddL);
          }
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, multifocalAddLConfirm]);

  useEffect(() => {
    if (usePDMeter) {
      const calculatedSize = (calculatedPd / 2) % 0.5 != 0 ? ((calculatedPd / 2) + 0.25) : (calculatedPd / 2);
      if (newPd.type == 'mono') {
        setNewPd(Object.assign({}, newPd, { "left": calculatedSize + '', "right": calculatedSize + '', "source": "o-pm" }))
      } else {
        setNewPd(Object.assign({}, newPd, { "pd": calculatedPd, "source": "o-pm" }))
      }

      localStorage.setItem('calculatedPd', JSON.stringify({ 'pd': calculatedPd, 'monoPD': calculatedSize + '' }))
      dispatch(setUseThisPD(false))
    }
  }, [usePDMeter])

  return (
    <>
      {isPdListLoading && (
        <div className="flex h-full items-center justify-center">
          <Spinner fill="black" width={32} height={32} />
        </div>
      )}
      {!isPdListLoading && (
        <>
          {!isProfilePage && <div className="flex-1 items-center text-center relative">
            <h5 className="font-medium text-center text-black mb-2 text-2xl  ">
              {'Enter your Prescription'}
            </h5>


            <div className='text-center font-medium mb-2'>{productFeatureCache.get && productFeatureCache?.get(purpose).title}</div>
            <div className='flex items-center mt-4 lgx:max-w-[3100px] lgx:mx-auto justify-around flex-col'>

              <>
                <div className='cursor-pointer mt-2 text-brand-blue text-center flex mb-1' onClick={() => setPrescriptionShowStep('SHOW_SELECTIONS')}>
                  <PrescriptionLeftArrow />Choose another method to add prescription</div>
              </>
              {/* {(isLogin && !isMultifocalOrBifocal) && (
                <>
                  <div className='cursor-pointer mt-2 inline-block text-brand-blue text-center flex-1' onClick={handleMySavedPrescriptions}>
                    {!isProfilePage && <span className="lgx:mx-auto items-center text-center relative mr-6"><AccountAlt className="lg:inline-block mx-auto -mt-1 lg:mr-2" fill="#00acc7" />List my saved prescription(s)</span>}
                  </div>
                </>
              )} */}
              {/* {(purpose == 'multifocal' || purpose == 'bifocal') && <div className='cursor-pointer mt-2 text-brand-blue text-center flex' onClick={() => setUploadFormOpen(true)}>
                <DocumentUpload className="lg:inline-block lgx:mx-auto mr-2 -mt-1" fill='#00acc7' />Upload prescription</div>} */}
            </div>
          </div>}
          <form
            className="flex w-full border-t border-brand-grey500 mt-8 pt-8 flex-col pr-[8px]"
            onSubmit={handleSubmit(onPrescriptionSubmit, onError)}>
            <div className="grid grid-cols-[3fr,3fr,4fr,2fr,3fr] gap-x-3 gap-y-4 mdx:grid-cols-2">
              <div className="font-sans text-[14px] text-brand-black100 md:order-[1] md:col-span-2 md:pr-[10px] md:text-right mdx:order-[3] mdx:col-span-2">
                Sphere (SPH)
              </div>
              <div className="font-sans text-[14px] text-brand-black100 md:order-[2] md:text-center mdx:order-[6] mdx:col-span-2">
                Cylinder (CYL)
              </div>
              <div className="font-sans text-[14px] text-brand-black100 md:order-[3] md:text-center mdx:order-[9] mdx:col-span-2">
                Axis
              </div>
              <div className="font-sans text-[14px] text-brand-black100 md:order-[4] md:text-center mdx:order-[12] mdx:col-span-2">
                Add
              </div>
              <div className="mt-1 font-sans text-sm font-medium md:order-[5] mdx:order-first">
                Right (OD)
              </div>
              <div className="md:order-[6] mdx:order-[4]">
                <div className="w-full">
                  <PrescriptionSelectBox
                    control={control}
                    rules={{ required: true }}
                    name="sphereR"
                    errorMessage="The Right Axis field is required when the Right Cylinder field has value"
                    id="sphere"
                    wrapperClass="rounded-[6px] w-full bg-white border border-brand-grey400"
                    labelClass="text-brand-grey75 font-normal text-xs"
                    helperClass="!bottom-[14px]"
                    className="bg-brand-grey125 !pb-2 text-sm font-medium text-brand-grey300"
                    options={createPrescriptionValue(12, -18)}
                  />
                </div>
              </div>
              <div className="md:order-[7] mdx:order-[7]">
                <div className="w-full">
                  <PrescriptionSelectBox
                    control={control}
                    name="cylinderR"
                    id="cylinder"
                    errorMessage="The Right Axis field is required when the Right Cylinder field has value"
                    rules={{
                      validate: (v: string) => {
                        if (
                          v &&
                          control?._fields?.axisR?._f.value &&
                          control?._fields?.axisR?._f.value !== '0'
                        ) {
                          // clearErrors('axisR');
                          return true;
                        } else if (
                          (!v && !control?._fields?.axisR?._f.value) ||
                          (v === '0' &&
                            control?._fields?.axisR?._f.value === '0')
                        ) {
                          return true;
                        }
                        return false;
                      }
                    }}
                    wrapperClass="rounded-[6px] w-full bg-white border border-brand-grey400"
                    labelClass="text-brand-grey75 font-normal text-xs"
                    className="bg-brand-grey125 !pb-2 text-sm font-medium text-brand-grey300"
                    helperClass="!bottom-[14px]"
                    options={createPrescriptionValue(0, -6, false)}
                  />
                </div>
              </div>
              <div className="md:order-[8] mdx:order-[10]">
                <div className="w-full">
                  <input
                    {...register('axisR')}
                    id="axis"
                    type="number"
                    className={`custom-number-input bg-brand-white rounded-md h-[38px] px-3 text-sm font-medium text-brand-grey300 border-brand-grey400 ounded-[10px] w-full bg-white border border-brand-grey40 `}
                  />
                </div>
              </div>
              <div className="md:order-[9] mdx:order-[13]">
                <div className="w-full">
                  <PrescriptionSelectBox
                    control={control}
                    errorMessage="The Right Cylinder field is required when the Right Axis field has value"
                    rules={{
                      validate: (v: string) => {
                        return true;
                      }
                    }}
                    name="addR"
                    id="add"
                    wrapperClass="rounded-[6px] w-full bg-white border border-brand-grey400"
                    labelClass="text-brand-grey75 font-normal text-xs"
                    helperClass="!bottom-[14px]"
                    className="bg-brand-grey125 !pb-2 text-sm font-medium text-brand-grey300"
                    options={
                      (isMultifocal || isBifocal || isReading)
                        ? addZero(createPrescriptionValue(isMultifocal || isReading ? 4.0 : 3.0, 0.75))
                        : createPrescriptionValue(4, 0)
                    }
                  />
                </div>
              </div>
              <div className="mt-1 font-sans text-sm font-medium md:order-[10] mdx:order-[2]">
                Left (OS)
              </div>
              <div className="md:order-[11] mdx:order-[5]">
                <div className="w-full">
                  <PrescriptionSelectBox
                    control={control}
                    name="sphereL"
                    id="sphereL"
                    wrapperClass="rounded-[6px] w-full bg-white border border-brand-grey400"
                    labelClass="text-brand-grey75 font-normal text-xs"
                    helperClass="!bottom-[14px]"
                    className="bg-brand-grey125 !pb-2 text-sm font-medium text-brand-grey300"
                    options={createPrescriptionValue(12, -18)}
                  />
                </div>
              </div>
              <div className="md:order-[12] mdx:order-[8]">
                <div className="w-full">
                  <PrescriptionSelectBox
                    control={control}
                    errorMessage="The Left Axis field is required when the Left Cylinder field has value"
                    rules={{
                      validate: (v: string) => {
                        if (
                          v &&
                          control?._fields?.axisL?._f.value &&
                          control?._fields?.axisL?._f.value !== '0'
                        ) {
                          // clearErrors('axisL');
                          return true;
                        } else if (
                          (!v && !control?._fields?.axisL?._f.value) ||
                          (v === '0' &&
                            control?._fields?.axisL?._f.value === '0')
                        ) {
                          return true;
                        }
                        return false;
                      }
                    }}
                    name="cylinderL"
                    id="cylinderL"
                    wrapperClass="rounded-[6px] w-full bg-white border border-brand-grey400"
                    labelClass="text-brand-grey75 font-normal text-xs"
                    className="bg-brand-grey125 !pb-2 text-sm font-medium text-brand-grey300"
                    helperClass="!bottom-[14px]"
                    options={createPrescriptionValue(0, -6, false)}
                  />
                </div>
              </div>
              <div className="md:order-[13] mdx:order-[11]">
                <div className="w-full">
                  <input
                    {...register('axisL')}
                    type="number"
                    id="axisL"
                    className={`custom-number-input bg-brand-white rounded-md h-[38px] px-3 text-sm font-medium text-brand-grey300 border-brand-grey400 ounded-[10px] w-full bg-white border border-brand-grey40 `}
                  />
                </div>
              </div>
              <div className="md:order-[14] mdx:order-[14]">
                <div className="w-full">
                  <PrescriptionSelectBox
                    control={control}
                    id="addL"
                    name="addL"
                    wrapperClass="rounded-[6px] w-full bg-white border border-brand-grey400"
                    labelClass="text-brand-grey75 font-normal text-xs"
                    className="bg-brand-grey125 !pb-2 text-sm font-medium text-brand-grey300"
                    helperClass="!bottom-[14px]"
                    options={
                      (isMultifocal || isBifocal || isReading)
                        ? addZero(createPrescriptionValue(isMultifocal || isReading ? 4.0 : 3.0, 0.75))
                        : createPrescriptionValue(4, 0)
                    }
                  />
                </div>
              </div>
            </div>
            <div className="my-8 mb-2 h-[1px] w-full bg-brand-grey500 mdx:my-2"></div>
            {/* <div>
              <div className="mt-[21px] grid grid-cols-[1fr,4fr] mdx:grid-cols-1 mdx:gap-[15px]">
                <div className="flex items-start font-medium ">
                  <span className="text-[14px]">PD</span>
                  <UITooltip
                    id="pd-upload-pd"
                    border={true}
                    borderColour={'#D7D8D7'}
                    textColour={'#000'}
                    backgroundColour={'#FFF'}
                    message={
                      <div>
                        <p className="font-normal">
                          Pupil distance (PD) measures the space between the
                          pupils of your eyes.
                        </p>
                        <Link href="/our-glasses/measure-your-pd">
                          <a
                            target="_blank"
                            className="mt-[4px] text-[12px] font-medium transition-colors hover:text-brand-orange">
                            How to measure your PD?
                          </a>
                        </Link>
                      </div>
                    }
                    place="top"
                    wrapperClassName="mt-[2px] ml-[12px]">
                    <Info className="cursor-pointer" />
                  </UITooltip>
                </div>
                <div className="flex flex-col relative">
                  {isLogin && pdSelectionType === 'SELECT' && (
                    <span
                      onClick={() => {
                        setSelectedPdId('');
                        setPdSelectionType('CREATE');
                      }}
                      className="mb-[12px] ml-auto inline-flex cursor-pointer items-center text-[14px] font-medium transition-colors hover:text-brand-orange">
                      <PlusAlt fill="currentColor" className="mr-[8px]" />
                      <span>Create PD</span>
                    </span>
                  )}
                  {isLogin && pdSelectionType === 'CREATE' && (
                    <span
                      onClick={() => {
                        setNewPd({ type: 'bino', pd: '', left: '', right: '', source: 'we' });
                        setPdSelectionType('SELECT');
                      }}
                      className="mb-[12px] ml-auto inline-flex cursor-pointer items-center text-[14px] font-medium transition-colors hover:text-brand-orange">
                      <CrossMarkAlt
                        fill="currentColor"
                        className="mr-[8px] mt-[2px]"
                      />
                      <span>Select existing PD</span>
                    </span>
                  )}
                  {pdSelectionType === 'SELECT' && (
                    <UIPDSelect
                      options={pdList}
                      value={selectedPdId}
                      placeholder="Select PD value"
                      onChanged={setSelectedPdId}
                    />
                  )}
                  {pdSelectionType === 'CREATE' && (
                    <>
                      <UICreatePDSelect
                        frameSize={frameSize as any}
                        value={newPd}
                        onChange={setNewPd}
                      />
                      <a className="p-1 text-brand-blue top-10 cursor-pointer" onClick={() => {
                        dispatch(setShowModal(true))
                      }}>Measure your PD size!</a>
                    </>
                  )}

                </div>
              </div>
            </div> */}

            {selectEditedPrescription &&
              selectEditedPrescription.files.length > 0 &&
              !fileRemoved ? (
              <>
                <div className="mt-1 font-sans text-sm font-medium">
                  <p>Prescription file</p>
                </div>
                <div className="mt-1 font-sans text-sm font-medium">
                  <div className="flex">
                    <a
                      href={
                        selectEditedPrescription.files[
                          selectEditedPrescription.files.length - 1
                        ].full_path
                      }
                      target="_blank"
                      rel="noreferrer">
                      <div className="flex">
                        <SelectIcon />
                        <span className="ml-2">View attached prescription</span>
                      </div>
                    </a>
                    <Button
                      className="ml-auto flex cursor-pointer px-0 py-0"
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure want to remove this file?',
                          showCancelButton: true,
                          confirmButtonColor: '#DA6767',
                          cancelButtonColor: '#DADEDA',
                          confirmButtonText: 'Yes, delete'
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setFileRemovedLoading(true);
                            axios
                              .get(
                                process.env.NEXT_PUBLIC_LARAVEL_URL +
                                '/me/removePrescriptionFile/' +
                                selectEditedPrescription.id,
                                {
                                  headers: {
                                    Authorization: 'Bearer ' + authToken //the token is a variable which holds the token
                                  }
                                }
                              )
                              .then(() => {
                                const updatedPresciption = Object.assign(
                                  {},
                                  selectEditedPrescription
                                );
                                updatedPresciption['files'] = [];

                                const updatedPrescriptions = prescriptions.map(
                                  (el: { id: any }) =>
                                    el.id === selectEditedPrescription.id
                                      ? updatedPresciption
                                      : el
                                );
                                dispatch(
                                  setPrescriptions(updatedPrescriptions)
                                );
                                dispatch(
                                  setSelectEditedPrescription(
                                    updatedPresciption
                                  )
                                );
                                if (
                                  selectedPrescription.id ===
                                  selectEditedPrescription.id
                                ) {
                                  dispatch(
                                    setSelectedPrescription(updatedPresciption)
                                  );
                                }
                                setFileRemovedLoading(false);
                                setFileRemoved(true);
                              });
                          }
                        });
                      }}>
                      {fileRemovedLoading ? (
                        <Spinner fill="black" />
                      ) : (
                        <Trash />
                      )}
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <>

                {!fileUpload && <div className="mt-[24px] text-sm text-brand-blue" >
                  <label htmlFor="filelabel" className="cursor-pointer inline-flex">
                    <DocumentUpload className='mr-2' /> Attach your prescription <span className="text-xs ml-1 mt-0.5 text-brand-grey450">(optional)</span>
                  </label>

                </div>}
                <div className="relative">
                  <input
                    id="filelabel"
                    type="file"
                    className="hidden"
                    accept="image/png, image/jpeg, application/pdf"
                    {...register('file', {
                      validate: (file: any) => {
                        if (file && file[0].size > 3145728) {
                          return false;
                        }
                        return true;
                      },
                      onChange: (e) => {
                        var fileInput = false;
                        if (e.target.files[0]) {
                          fileInput = true;
                        }

                        const fileExtension = e.target?.files?.[0]?.name.toLocaleLowerCase()
                          ?.split?.('.')
                          ?.pop?.();
                        if (!ALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
                          return;
                        }

                        if (
                          fileInput &&
                          e.target.files[0].type.includes('image')
                        ) {
                          try {
                            Resizer.imageFileResizer(
                              e.target.files[0],
                              1920,
                              1080,
                              'JPEG',
                              65,
                              0,
                              (uri: any) => {
                                setFile(uri);
                                setFileUpload(true);
                                setFileIsPdf(false);
                              },
                              'file',
                              200,
                              200
                            );
                          } catch (err) {
                            console.log(err);
                          }
                        } else {
                          setFile(e.target.files[0]);
                          setFileUpload(true);
                          setFileIsPdf(true);
                        }
                        setFileSrc(URL.createObjectURL(e.target.files[0]));
                        setFileName(e.target.files[0].name);
                      }
                    })}
                  />

                  {fileUpload && (
                    <div className="flex items-between px-4 w-full bg-white items-center rounded">
                      <div className="mr-[12px] flex h-[32px] w-[32px] flex-shrink-0 items-center justify-center rounded-full bg-brand-orange">
                        <Checkmark fill="#fff" />
                      </div>
                      <div className="my-4 flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap font-sans text-sm">
                        <div>
                          <div className="text-sm font-semibold">Prescription selected</div>
                          <a
                            href={fileSrc}
                            target="_blank"
                            className="cursor-pointer text-brand-grey450 mx-w-lg"
                            rel="noreferrer">
                            {fileName}
                          </a>
                        </div>
                      </div>
                      <label
                        onClick={() => {
                          setFileUpload(false);
                          setValue('file', null);
                          setFile(null);
                          clearErrors('file');
                        }}
                        className="">
                        <TrashAlt
                          fill="currentColor"
                        />{' '}
                      </label>
                    </div>
                  )}
                </div>

                {errors.file && (
                  <div
                    className="mt-1 md:order-[20] mdx:order-[20]"
                    style={{ color: '#d83e3e', fontSize: '70%' }}>
                    File too big or not formatted
                  </div>
                )}
              </>
            )}

            {!addNote && <div className="text-brand-blue text-sm mt-2 leading-6 inline-flex" onClick={() => setAddNote(true)}><AddNote className='mr-2 ml-1.5' /> Add Note</div>}
            {addNote &&
              <span>
                <div className="flex mt-2 mdx:flex-col">
                  <div className="mdx:[w-full] w-[25%] mdx:mb-4">
                    <label
                      htmlFor="addressname"
                      className="font-sans text-sm font-medium text-brand-black75">
                      Notes
                    </label>
                  </div>
                  <textarea
                    onFocus={() => {
                      setButtonSticky(false);
                    }}
                    {...register('note', {
                      onBlur: () => {
                        setButtonSticky(true);
                      }
                    })}
                    id="addressname"
                    placeholder="Type your additional notes here..."
                    className="focus:outline-none h-[75px] w-[80%] resize-none rounded border border-brand-grey350 bg-white p-3 text-[14px] font-normal text-black placeholder-brand-grey75 mdx:w-full"
                  />
                </div></span>}

            {/* <Button
              type="submit"
              className={
                'bottom-0 mt-5 mb-[12px] w-full justify-center bg-brand-black100 text-center ' +
                (buttonSticky && 'sticky bottom-[10px]')
              }
              textClass="font-medium text-white text-sm"
              disabled={createPrescriptionLoading}>
              <div className="flex">
                {selectEditedPrescription
                  ? 'Update prescription'
                  : 'Add prescription'}
                {createPrescriptionLoading ? (
                  <div className="ml-2 mt-1">
                    <Spinner fill="white" />
                  </div>
                ) : null}
              </div>
            </Button> */}
            <div className="mt-2 mb-4 text-sm flex">
              <input id="hp" className={`dresden-checkbox mb relative m-2 pt-2 w-4 h-4 rounded border-brand-grey400`} type="checkbox" onClick={() => setHaveValidPrescription(!haveValidPrescription)} />
              <label className='leading-normal mt-3 pt-0.5 ml-2'>
                <div>
                  <span className='whitespace-nowrap inline-block'>
                    I confirm that I have a
                  </span>
                  <span className="ml-1 inline-block">
                    <UITooltip place="top"
                      border={true}
                      borderColour={'#D7D8D7'}
                      textColour={'#000'}
                      backgroundColour={'#FFF'}
                      messageWrapperClassName={'mb-3 mt-3'}
                      tooltipWrapperClassName={'!max-w-[300px] leading-normal justify-center items-center md:before-selector-override md:after-selector-override shadow-tooltip'}
                      message={tooltipMessageLocale[router?.locale as string]}
                      id={'book'}><div className='text-brand-blue whitespace-nowrap'>valid glasses prescription.</div>
                    </UITooltip>
                  </span>
                </div>
              </label>
            </div>
            <UIButton className='mt-4 max-w-xs' disabled={!haveValidPrescription} >Confirm Prescription</UIButton>

          </form>
          {
            <UIModal isVisible={uploadFormOpen}
              onToggleVisibility={() => {
                setUploadFormOpen(!uploadFormOpen)
                setUploadFormFileSelected(false)

              }}

              modalCardClassName={cx('max-w-[460px] rounded-xl w-full z-9 p-4 2xlx:!mt-20')}
              closeable={false}>
              <div className="mx-auto py-10 mt">
                <div className='absolute right-2 top-2' onClick={() => {
                  setUploadFormOpen(!uploadFormOpen)
                  setUploadFormFileSelected(false)
                }}> <CrossMarkAlt width={18} height={18} className='mt-2 mr-2' /> </div>
                <PrescriptionUploadForm />
              </div>
            </UIModal>

          }
        </>
      )
      }
    </>
  );
}
